<script>
export default {
  name: 'BookingFetchError',
  props: {
    error: {
      type: Object,
      default: () => ({
        status: null,
        code: null,
        title: null,
        subTitle: null,
      }),
    },
  },
}
</script>

<template>
  <div class="booking-fetch-error-div">
    <v-icon size="64">mdi-close-circle-outline</v-icon>
    <div class="content">
      <div class="error-title">{{ error.title }}</div>
      <div class="error-sub-title">{{ error.subTitle }}</div>
      <div class="error-message">({{ error.status }}) {{ error.code }}</div>
    </div>
    <BaseButton
      class="go-back"
      width="96"
      height="44"
      :border-radius="'8px'"
      @click="$emit('backClicked')"
    >
      {{ $t('general.goBack') }}
    </BaseButton>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';

.booking-fetch-error-div {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  text-align: center;
  transform: translate(0%, -50%);

  .v-icon {
    margin-bottom: 12px;
    color: $color-black;
  }

  .content {
    div {
      margin: 18px 0;
    }

    .error-title {
      font-size: 32px;
      font-weight: 600;
      line-height: 100%;
      color: $color-black;
      text-align: center;
      letter-spacing: -1.5px;
    }

    .error-sub-title {
      font-size: 16px;
      font-weight: 400;
      line-height: 100%;
      color: $color-black;
      text-align: center;
      letter-spacing: 0.25px;
    }

    .error-message {
      font-size: 16px;
      font-style: medium;
      font-weight: 500;
      line-height: 100%;
      color: $color-grey-550;
      text-align: center;
      letter-spacing: 0.25px;
    }
  }

  .go-back {
    padding: 10px 18px !important;
    margin-top: 10px;
  }
}

@media (max-width: 767px) {
  .booking-fetch-error-div {
    .v-icon {
      margin-bottom: 5px;
      font-size: 50px !important;
    }
    .content {
      div {
        margin: 14px 0;
      }
      .error-title[data-v-15a4e8aa] {
        font-size: 24px;
      }
    }
  }
}
</style>
